<template>
  <div id="app" class="container">
    <div class="left-reg">
      <div class="city-icon">
        <img src="@/assets/city-logo.png" alt="">
      </div>
      <div class="area-name">萬里區</div>
      <div class="area-icon">
        <img src="@/assets/icon.svg" alt="">
      </div>
    </div>
    <div class="right-reg">
      <div class="lane">新北大道一段</div>
      <div class="number-wrapper">
        <div class="alley-name">199 巷 10 弄</div>
        <div class="alley-number">
          <span class="big">10</span> 
          <span class="word">之</span>
          <span class="small">3</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
}
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.container {
  width: 634px;
  height: 414px;
  background: #1e987b;
  border-radius: 30px;
  display: flex;
  overflow: hidden;
}
.container .left-reg {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-left: .9em;
  width: 30%;
}
.container .city-icon {
  padding-top: 2em;
}
.container .city-icon img {
  width: 90px;
}
.container .area-name {
  color: white;
  font-size: 3em;
}
.container .area-icon img {
  width: 160px;
  margin-bottom: -10px;
}
.container .right-reg {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  width: 70%;
}
.container .right-reg .lane {
  color: white;
  font-size: 3.6em;
  font-weight: bolder;
  margin-bottom: -.2em;
  padding-top: .6em;
}
.container .right-reg .number-wrapper {
  background: white;
  border-radius: 30px;
  width: 400px;
  height: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: #a90a4d;
  margin-bottom: 0.4em;
  font-weight: bolder;
  font-style: italic;
}
.container .right-reg .number-wrapper .alley-name {
  font-size: 3em;
  margin-bottom: -10px;
}
.container .right-reg .number-wrapper .alley-number .big {
  font-size: 10em;
}
.container .right-reg .number-wrapper .alley-number .word {
  font-size: 2em;
  margin: 0 5px;
}
.container .right-reg .number-wrapper .alley-number .small {
  font-size: 5em;
}
</style>
